export default "__VITE_ASSET__CHs4814a__"